/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:36:37
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:28:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/PageSetting/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React from 'react';
//import css from './css.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Input from 'src/constrains/DebounceRequestInput';
//import { Input } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import { legalPermissions } from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/hooks/permission';
import {
  EnumCollapseId,
  getCollapse,
  getPageSetting,
  onCollapseChange,
  onPageSettingChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice';
import { postCheckLegalName } from 'src/request/salesChannel/legal';
import { NEW } from 'src/tools/constant';
import { generateErrorKey } from 'src/tools/helper';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const _postCheckLegalName = (body) => {
  return postCheckLegalName(body, {
    [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  });
};
const PageSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _data: any = useSelector(getPageSetting());
  const p: any = useParams();

  const { legalPageUuid, uuid } = p;
  const isNew = legalPageUuid == NEW;
  const fixedParams = {
    salesChannelUuid: uuid,
    uuid: isNew ? null : legalPageUuid,
  };
  const _d = useDispatch();
  const { canEdit } = legalPermissions(uuid);
  const {
    name, //isNameDuplicate
    nameIsValid,
  } = _data || {};
  const nameError = _data[generateErrorKey('name')];

  const handleOnNameChange = ({ text, valid }) => {
    _d(onPageSettingChange({ name: text, nameIsValid: valid }));
  };

  return (
    <SectionContent>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(name || '').length} allCount={100} />
                }
                title={`${getI18n('general.pageName')}*`}
                id='SalesChannelLegalPageEditorPageName'>
                <Input
                  customError={nameError}
                  customHelper={getI18n(
                    'legalPage.index.legalPageNamecannotbeempty',
                  )}
                  invalidHelper={getI18n(
                    'legalPage.index.alegalpagenameexists',
                  )}
                  displayDangerousNotice={true}
                  maxLength={100}
                  onChange={handleOnNameChange}
                  value={name}
                  isValid={nameIsValid}
                  size='large'
                  checkFunction={_postCheckLegalName}
                  fixedParams={fixedParams}
                  disabled={!canEdit}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionContent>
  );
};

export default SectionHOC(PageSetting, {
  id: EnumCollapseId.PageSetting,
  title: getI18nFromGeneral('general.hOCTitle.pageSetting'),
  getCollapse,
  onCollapseChange,
  cannotCollapse: true,
});
